<script setup lang="ts">
  import { UIButton } from '@gohighlevel/ghl-ui'
  import { computed, PropType } from 'vue'
  import { IRecipient, APP_STORE_META, RecipientEntityTypeEnum, Role } from '@gohighlevel/ghl-proposals-common'
  import { Trash01Icon, Pencil01Icon } from '@gohighlevel/ghl-icons/24/outline'
  import { useAppStore } from '@/store/app'
  import { useElementOption } from '@/composable/elementOptions'
  import { useBuilderStore } from '@/store/builder'
  import UserAvatar from '@/components/common/UserAvatar.vue'

  const { updateDocumentOption } = useElementOption()
  const store = useBuilderStore()
  const appStore = useAppStore()

  const props = defineProps({
    recipient: { type: Object as PropType<IRecipient> },
    delete: { type: Boolean, default: false },
  })

  const emits = defineEmits(['edit-role'])

  const isRole = computed(() => props.recipient?.entityName === RecipientEntityTypeEnum.ROLE)

  const deleteRecipient = (recipientId: string) => {
    if (recipientId) {
      const recipients = appStore.document?.recipients?.filter((el: any) => {
        return el.id !== recipientId
      })
      updateDocumentOption(APP_STORE_META.RECIPIENTS, recipients)
    }
  }

  const onEditRole = () => {
    const role = (appStore.document?.roles || []).find((r: Role) => r.name === props.recipient?.id)
    if (role) emits('edit-role', role)
  }

  const onDeleteRole = () => {
    if (props.recipient?.id) store.deleteRole(props.recipient.id)
  }
</script>

<template>
  <div class="flex flex-col relative" v-if="recipient?.id">
    <UserAvatar :recipient="recipient" :show-recipient-tag="true" :show-sender-info="true" />
    <div class="flex-none absolute right-0 top-3" v-if="props.delete && recipient.entityName === 'contacts' && store.isDocumentEditable">
      <UIButton :id="`btn_custom_${recipient?.id}`" @click="deleteRecipient(recipient?.id)" :circle="true" :quaternary="true">
        <Trash01Icon class="w-4 h-4 cursor-pointer" />
      </UIButton>
    </div>

    <!-- Role recipients can be edited or removed inline. -->
    <div class="flex-none absolute right-0 top-3 flex items-center gap-1" v-if="isRole && store.isDocumentEditable">
      <UIButton :id="`btn_edit_role_${recipient?.id}`" @click="onEditRole" :circle="true" :quaternary="true">
        <Pencil01Icon class="w-4 h-4 cursor-pointer" />
      </UIButton>
      <UIButton :id="`btn_delete_role_${recipient?.id}`" @click="onDeleteRole" :circle="true" :quaternary="true">
        <Trash01Icon class="w-4 h-4 cursor-pointer" />
      </UIButton>
    </div>
  </div>
</template>
